import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import { ColumnMapping } from "../../types/SalesData/ColumnMapping";
import { SalesFile } from "../../types/SalesData/SalesFile";
import salesDataConstants from "../constants/salesDataContants";

const initialState: {
  masterColumns: any[];
  fileColumns: any[];
  filteredFileCols: string[];
  salesFiles: SalesFile[];
  salesFilesPending: boolean;
  resSalesFiles: any;
  newFile: any;
  masterData: any;
  masterDataResponse: any;
  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;
  downloadedSalesFileResponse: any;
  downloadSalesFilePending: Boolean;
} = {
  masterColumns: [],
  fileColumns: [],
  filteredFileCols: [],
  salesFiles: [],
  salesFilesPending: false,
  resSalesFiles: null,
  newFile: null,
  masterData: [],
  masterDataResponse: null,
  error: false,
  pending: false,
  fulfilled: false,
  downloadedSalesFileResponse: null,
  downloadSalesFilePending: false,
};

const makeTable = (data: any[]): ColumnMapping[] => {
  const table: ColumnMapping[] = [];
  data.forEach((element) => {
    table.push({
      masterColumn: element,
      rawColumn: "",
    });
  });

  return table;
};

const makeColumns = (data: string[]): any[] => {
  const cols: any[] = [];
  data.forEach((element) => {
    cols.push({ label: element, value: element, disabled: false });
  });
  return cols;
};

const markMapped = (data: any[], index: number, mappedTo: string) => {
  const res = data as ColumnMapping[];
  res[index].rawColumn = mappedTo;
  return res;
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case salesDataConstants.EDIT_MASTER_DATA_REQUEST:
    case salesDataConstants.DELETE_MASTER_DATA_REQUEST:
    case salesDataConstants.PROCESS_MASTER_DATA_REQUEST:
    case salesDataConstants.DELETE_SALES_FILE_REQUEST:
    case salesDataConstants.DELETE_PROCESSED_FILE_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case salesDataConstants.EDIT_MASTER_DATA_SUCCESS:
    case salesDataConstants.DELETE_MASTER_DATA_SUCCESS:
    case salesDataConstants.PROCESS_MASTER_DATA_SUCCESS:
    case salesDataConstants.DELETE_SALES_FILE_SUCCESS:
    case salesDataConstants.DELETE_PROCESSED_FILE_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case salesDataConstants.EDIT_MASTER_DATA_FAILURE:
    case salesDataConstants.DELETE_MASTER_DATA_FAILURE:
    case salesDataConstants.PROCESS_MASTER_DATA_FAILURE:
    case salesDataConstants.DELETE_SALES_FILE_FAILURE:
    case salesDataConstants.DELETE_PROCESSED_FILE_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };

    case salesDataConstants.GET_MASTER_DATA_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case salesDataConstants.GET_MASTER_DATA_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        masterData: action.payload.data.results,
        masterDataResponse: action.payload.data,
      };
    case salesDataConstants.GET_MASTER_DATA_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };

    case salesDataConstants.MAP_TO_RAW_DATA_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case salesDataConstants.MAP_TO_RAW_DATA_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case salesDataConstants.MAP_TO_RAW_DATA_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };

    case salesDataConstants.COLUMN_MAP_REQUEST:
      return {
        ...state,
        masterColumns: markMapped(
          action.payload,
          action.index,
          action.mappedTo,
        ),
      };
    case salesDataConstants.SET_FILTERED_FILE_COLS_REQUEST:
      return {
        ...state,
        filteredFileCols: action.fileCols,
      };

    case salesDataConstants.POST_SALES_FILE_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };

    case salesDataConstants.GET_FILE_COLUMNS_REQUEST:
      return {
        ...state,
        ...RequestDefault,
        filteredFileCols: [],
        newFile: null,
      };
    case salesDataConstants.POST_SALES_FILE_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        newFile: action.payload.data,
      };

    case salesDataConstants.GET_FILE_COLUMNS_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        newFile: action.payload.data,
        filteredFileCols: action.payload.data.columns_list,
        masterColumns: makeTable(action.payload.data.master_columns),
        fileColumns: makeColumns(action.payload.data.columns_list),
      };
    case salesDataConstants.POST_SALES_FILE_FAILURE:
    case salesDataConstants.GET_FILE_COLUMNS_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };

    case salesDataConstants.GET_SALES_FILES_REQUEST:
      return {
        ...state,
        ...RequestDefault,
        salesFilesPending: true,
      };
    case salesDataConstants.GET_SALES_FILES_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        salesFilesPending: false,
        salesFiles: action.payload.data.results,
        resSalesFiles: action.payload.data,
      };
    case salesDataConstants.GET_SALES_FILES_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
        salesFilesPending: false,
      };

    case salesDataConstants.DOWNLOAD_SALES_FILE_REQUEST:
      return {
        ...state,
        downloadSalesFilePending: true,
      };
    case salesDataConstants.DOWNLOAD_SALES_FILE_SUCCESS:
      return {
        ...state,
        downloadedSalesFileResponse: action.payload.data,
        downloadSalesFilePending: false,
      };
    case salesDataConstants.DOWNLOAD_SALES_FILE_FAILURE:
      return {
        ...state,
        downloadSalesFilePending: false,
      };

    case salesDataConstants.RESET_DOWNLOAD_SALES_FILE:
      return {
        ...state,
        downloadedSalesFileResponse: null,
      };
    case salesDataConstants.RESET_SALES_FILES:
      return {
        ...state,
        salesFiles: [],
        resSalesFiles: null,
      };

    default:
      return {
        ...state,
      };
  }
};
